/**
 * @fileoverview GET handler for the "/engagement/campaigns/aggregate_stats/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementCampaignsAggregateStatsAppGroupId } from "./constants";
import type { CampaignAggregateStatsResult } from "./types";

export const getCampaignAggregateStats = reactQueryFetcherAdapter(
  engagementCampaignsAggregateStatsAppGroupId,
  (signal: AbortSignal, appGroupId: string): Promise<CampaignAggregateStatsResult> => {
    return fetch(`/engagement/campaigns/aggregate_stats/${appGroupId}`, "GET", {}, { signal });
  }
);
